import { gql } from "@grandvisionhq/graphql";
import { productFragment } from "../../fragments/operations/queries/fragments/product.js";
import { variantFragment } from "../../fragments/operations/queries/fragments/variant.js";
import { commercialCategoryFragment } from "../../fragments/operations/queries/fragments/small-fragments.js";
const GET_SOLUTIONS_BY_SLUG = gql`
  query GetSolutionsBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on SolutionProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            exclusiveBrand
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              contactLensCareType
              packageOption
              solutionType

              targetUsers
              convenience
              keyInstructions

              lensTypeTarget
              caseIncluded
              minimumCycleTime
              preservativeFree
              maxTimeFrameInLensCase
              expirationAfterOpening

              hasDisinfect
              forHydration
              additionalComfort
              superiorCleaning
              forSensitiveEyes
              rinsable
              subscriptionIntervals
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
`;
export {
  GET_SOLUTIONS_BY_SLUG
};
//# sourceMappingURL=get-solutions-by-slug.js.map
